import { SubTitleWithTwoBox } from '@/components/general/title/sub-title/SubTitle';
import BannerLayout from '@/components/layout/banner-layout';
import { ekDomain, ROUTES } from '@/configs/constants';
import { isPathEk } from '@/utils/routes';
import { ReactNode } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';

export default function BookingLayout({ children }: { children?: ReactNode }) {
    // hook
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);
    const { bikeId, id } = useParams();

    const getUrlBikeDetail = (): string => {
        return isEk ?
            `/${ekDomain}/${ROUTES.locationList.href}/${ROUTES.locationDetailEnduser.href}/${id}/${ROUTES.bikeBookingDetail.href}/${bikeId}` :
            `/${ROUTES.locationList.href}/${ROUTES.locationDetailEnduser.href}/${id}/${ROUTES.bikeBookingDetail.href}/${bikeId}`;
    };
    return (
        <div>
            <BannerLayout title='バイクを予約する' className='sm:block hidden' subTitle='バイクを予約する' url={getUrlBikeDetail()} />
            <div className='mt-[min(120px,12vw)]'>
                <SubTitleWithTwoBox parentClassName='sm:hidden wrapper-container mb-[30px]' title='バイクを予約する' titleClassName='leading-[30px] mt-0' sub='RESERVE A BIKE' subClassName='font-sans leading-[18px]' />
                {
                    children ?? <Outlet />
                }
            </div>

        </div>
    );
}
